import { render, staticRenderFns } from "./ClaimRepairOptionList.vue?vue&type=template&id=051b4c10&"
import script from "./ClaimRepairOptionList.vue?vue&type=script&lang=js&"
export * from "./ClaimRepairOptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports